export default "__VITE_ASSET__D81NUI8P__"